import { useEffect, useRef } from "react";
import { SystemContentModel } from "../models/SystemContentModel";

interface ViewSystemContentCompProps {
    show: boolean;
    systemContent: SystemContentModel;
    onClose: () => void;
}
const ViewSystemContentComp: React.FC<ViewSystemContentCompProps> = ({ show, systemContent, onClose }) => {

    const modalRef = useRef<HTMLDivElement | null>(null);
    const bsModalRef = useRef<any>(null);

    useEffect(() => {
        if (modalRef.current) {
            bsModalRef.current = new (window as any).bootstrap.Modal(modalRef.current);
            modalRef.current.addEventListener('hidden.bs.modal', onClose);
        }
        return () => {
            modalRef.current?.removeEventListener('hidden.bs.modal', onClose);
        };
    }, []);

    useEffect(() => {
        if (show) {
            bsModalRef.current?.show();
        } else {
            bsModalRef.current?.hide();
        }
    }, [show]);

    return (
        <div className="modal fade" tabIndex={-1} ref={modalRef} data-bs-backdrop="static" data-bs-keyboard="false" >
            <div className="modal-dialog modal-lg">
                <div className="modal-content rounded-0">
                    <div className="modal-header">
                        <h5 className="modal-title">{systemContent.contentName} v{systemContent.contentVersion}</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => bsModalRef.current?.hide()}
                        ></button>
                    </div>
                    <div className="modal-body" style={{
                        maxHeight: '60vh', // or any value like 500px
                        overflowY: 'auto'
                    }}>
                        <div  style={{ whiteSpace: "pre-line" }} dangerouslySetInnerHTML={{ __html: systemContent.contentText }}></div>
                    </div>
                    <div className="modal-footer d-flex ">
                        <button className="btn btn-outline-dark rounded-0 float-end" onClick={onClose}>
                            Close
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
}
export default ViewSystemContentComp;